import { AssistantAPI } from "@/api/AssistantAPI";

export const assistantModule = {
    state: () => ({
        dialog: [],
        isOpen: 'assistant-profile',
        language: localStorage.getItem('locale') || ''
    }),
    getters: {
        dialog: state => state.dialog,
        assistantStatus: state => state.isOpen,
        lang: state => state.language
    },
    mutations: {
        setAssistantType(state, data){
            if (data === 'current'){
                data = state.isOpen || 'assistant-profile'
            }
            state.isOpen = data
        },
        setMessage(state, data) {
            const message = {
                id: Date.now(),
                owner: 'bot',
                type: 'category',
                answer: data
            }
            state.dialog.push(message)
        },
        setSubCategory(state, data) {
          const message = {
              id: Date.now(),
              owner: 'bot',
              type:'subCategory',
              answer: data
          }
          state.dialog.push(message)
        },
        setQuestion(state, data) {
            const message = {
                id: Date.now(),
                owner: 'bot',
                type: data.length ? 'question' : 'errorAnswer',
                answer: data.length ? data : 'incomprehensibleRequest'
            }
            state.dialog.push(message)
        },
        setAnswer(state, data) {
            const message = {
                id: Date.now(),
                owner: 'bot',
                type: 'answer',
                answer: data.answer
            }
            state.dialog.push(message)
        },
        setUserQuestion(state, data) {
            const message = {
                id: Date.now(),
                owner: 'user',
                type: 'answer',
                answer: data
            }
            state.dialog.push(message)
        },
        clearDialog(state) {
            state.dialog.length = 0
        },
        setLanguage(state, lang) {
          state.language = lang
        }
    },
    actions: {
      async getCategory({ state, commit }){
        return await AssistantAPI.getCategory(state.language)
          .then(res => {
            commit("clearDialog")
            commit("setMessage", res.data)
            return res.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      },
      async getQuestion({ commit }, categoryId){
        return await AssistantAPI.getQuestion(categoryId)
          .then(res => {
            commit("setQuestion", res.data)
            return res.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      },
      async getSubCategory({ commit }, categoryId){
        return await AssistantAPI.getSubCategory(categoryId)
          .then(res => {
            if(res.data.hasOwnProperty('sub_category') && res.data.hasOwnProperty('questions')){
              commit("setSubCategory", res.data)
            }else if(res.data.hasOwnProperty('sub_category')){
              commit("setMessage", res.data.sub_category)
            }else if(res.data.hasOwnProperty('questions')){
              commit("setQuestion", res.data.questions)
            }else{
              commit("setAnswer", {answer: "Информация отсутствует"})
            }
            return res.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      },
      async getAnswer({ commit }, questionId){
        return await AssistantAPI.getAnswer(questionId)
          .then(res => {
            commit("setAnswer", res.data)
            return res.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      },
      async submitQuestion({ state, commit }, question){
        commit("setUserQuestion", question)
        return await AssistantAPI.submitQuestion({question, language: state.language})
          .then(res => {
            commit("setQuestion", res.data)
            return res.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      },
      async requestACall({ commit }, callData){
        return await AssistantAPI.requestCall(callData)
          .then(res => {
            return res.status;
          })
          .catch((error) => {
            let errorStatus = error.response.status

            if (String(errorStatus).startsWith('4')){
              commit('clientError', null, { root: true })
            }else if(String(errorStatus).startsWith('5')){
              commit('serverError', null, { root: true })
            }
            
            return errorStatus;
          });
      }
    },
    namespaced: true
}